import classNames from "classnames";
import React from "react";
import { clampValue, isValidNumber } from "../../utils/number-utils";
import { CSS_CLASSES } from "./progress-indicator-css-classes";
import { ProgressIndicatorValueLabelProps } from "./progress-indicator.types";

export const ProgressIndicatorValueLabel: React.FunctionComponent<ProgressIndicatorValueLabelProps> = React.memo(
  ({ value, size = "medium", className }) => {
    if (!isValidNumber(value)) {
      return null;
    }

    const valueLabelClassName = classNames(
      CSS_CLASSES.PROGRESS_INDICATOR_VALUE_LABEL,
      {
        [CSS_CLASSES.PROGRESS_INDICATOR_MEDIUM_VALUE_LABEL]: size === "medium",
        [CSS_CLASSES.PROGRESS_INDICATOR_LARGE_VALUE_LABEL]: size === "large",
      },
      className
    );

    return <span className={valueLabelClassName}>{`${clampValue(value).toFixed(0)}%`}</span>;
  }
);

ProgressIndicatorValueLabel.displayName = "ProgressIndicatorValueLabel";
